import { inject, Injectable } from '@angular/core';
import { BehaviorSubject, map, tap } from 'rxjs';
import { ISelectItem } from '../interfaces/select-item.interface';

@Injectable()
export class RolesSharedService {
  /* private rolesService = inject(RolesService); */
  private list$: BehaviorSubject<ISelectItem[]> = new BehaviorSubject<ISelectItem[]>([]);

  constructor() {
    /*this.loadRoles(); */
  }

  /* loadRoles() {
    this.rolesService.findAll().pipe(
      map((res) =>
        res.map((r) => ({
          label: r.label,
          value: r.code,
        })),
      ),
      tap((res) => this.list$.next(res)),
    );
  } */

  getRoles() {
    return this.list$;
  }
}
